import React, { useMemo } from 'react';
import OperationalMiniCard from './OperationalMiniCard';
import { buildOperationalSummaries } from '../../../utils/operationalOverviewSummaries';
import styles from './StandardOverview.module.css';

const OPERATIONAL_ITEMS = [
    {
        key: 'tasks',
        title: 'Tasks',
        actionLabel: 'Open Tasks →',
        route: '/tasks',
        summaryKey: 'tasks',
        featureKey: 'projectManagement',
    },
    {
        key: 'raid',
        title: 'RAID',
        actionLabel: 'Open RAID →',
        route: '/raid',
        summaryKey: 'raid',
        featureKey: 'raidLog',
    },
    {
        key: 'actionLog',
        title: 'Action Log',
        actionLabel: 'Open Action Log →',
        route: '/action-log',
        summaryKey: 'actionLog',
        featureKey: 'actionLog',
    },
    {
        key: 'observations',
        title: 'Observations',
        actionLabel: 'Open Observations →',
        route: '/observations',
        summaryKey: 'observations',
        featureKey: 'observations',
    },
];

const OperationalOverviewRow = ({ model }) => {
    const summaries = useMemo(() => buildOperationalSummaries(model), [model]);
    const items = OPERATIONAL_ITEMS.filter(item => model.features?.[item.featureKey]);

    if (!items.length) {
        return null;
    }

    return (
        <div className={styles.operationalRow}>
            {items.map(item => (
                <OperationalMiniCard
                    key={item.key}
                    title={item.title}
                    status={summaries[item.summaryKey]}
                    actionLabel={item.actionLabel}
                    route={item.route}
                />
            ))}
        </div>
    );
};

export default OperationalOverviewRow;
